import { Typography } from '@mui/material';
import React, { useMemo, FC, useCallback } from 'react';
import StyledBox from 'views/rebranded-module/GeoViewV2/components/GeoMarker/GeoMarker.styles';
import Pin from 'public/imgs/mapGroups/Pin';

const GeoMarker: FC<any> = (props) => {
  // disabled: true when a "Search this area" request is loading (isMapLoading).
  // Prevents pin clicks and applies the GMDisabled style (opacity + pointer-events: none).
  const { location, handleMarkerClick, hoveredBike, disabled } = props;

  const isSelected = useMemo(
    () => hoveredBike?.location?.id === location.id,
    [location, hoveredBike],
  );

  const handleClick = useCallback(() => {
    if (!disabled) {
      handleMarkerClick(location);
    }
  }, [disabled, handleMarkerClick, location]);

  return (
    <StyledBox
      onClick={handleClick}
      className={`${isSelected ? 'GMSelected' : ''} ${disabled ? 'GMDisabled' : ''}`}
    >
      <Pin className="GMPin" />
      <Typography component="span" variant="body2" className="GMNumber">
        {location.vehicles_count > 20 ? '20+' : location.vehicles_count}
      </Typography>
    </StyledBox>
  );
};

export { GeoMarker };
